import React from 'react';
import Button from '../../molecules/button';
import Icon from '../../atoms/icon';
import {
  faEdit,
  faPlusCircle,
  faUsers
} from '@fortawesome/pro-solid-svg-icons';
import Tooltip from '../tooltip';
import Popover from '../popover';
import { useTerms } from '../../../contexts/terms';
import { usePatientGroup } from '../../../contexts/patient-group';
import PatientGroupSelect from './select';
import cc from 'classcat';

interface PatientGroupControlProps {
  wrapperClassName?: string;
  toggleForm: (type: 'new' | 'edit') => void;
  setIsPGSelectExpanded: (isExpanded: boolean) => void;
  isStuck?: boolean;
}

const PatientGroupControl: React.FC<PatientGroupControlProps> = ({
  wrapperClassName = 'ma-0 inline-block font-bold',
  toggleForm,
  setIsPGSelectExpanded,
  isStuck,
  children
}) => {
  const { getActiveGroup, isLoading } = usePatientGroup();
  const { terms } = useTerms();
  const activeGroup = getActiveGroup();
  const isAllPatient = !isLoading && !activeGroup;
  const wrapperClass = cc([wrapperClassName, isStuck ? 'mt-1' : 'mt-2']);
  return (
    <div className={wrapperClass}>
      <Icon className="mr-2" icon={faUsers} />
      <Popover
        position="bottom"
        className="align-middle"
        onOpened={() => setIsPGSelectExpanded(true)}
        onClosed={() => setIsPGSelectExpanded(false)}
        content={
          <div className="overflow-y-auto" style={{ maxHeight: '55vh' }}>
            <PatientGroupSelect toggleForm={toggleForm} />
          </div>
        }
      >
        {children}
      </Popover>
      {isAllPatient ? (
        <Tooltip
          disabled={isStuck}
          content={
            <span className="font-normal text-small">
              Create New {terms.patient.capitalized} View
            </span>
          }
        >
          <Button
            variant="minimal"
            bare
            className="ml-2"
            aria-label={`Create New ${terms.patient.capitalized} View`}
            onClick={() => toggleForm('new')}
          >
            <Icon icon={faPlusCircle} />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip
          disabled={isStuck}
          content={
            <span className="font-normal text-small">
              Modify Current {terms.patient.capitalized} View
            </span>
          }
        >
          <Button
            variant="minimal"
            bare
            className="ml-2"
            aria-label={`Modify Current ${terms.patient.capitalized} View`}
            onClick={() => toggleForm('edit')}
          >
            <Icon icon={faEdit} />
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

export default PatientGroupControl;
